<footer class="jjsv-footer">
    <div class="jjsv-header__logo">
        <img src="/assets/svgs/footer-logo.svg" alt="J&amp;J logo" />
    </div>
</footer>